module.exports = __webpack_public_path__ + "img/h5_P2.c44f646b.jpg";